<template>
  <v-container class="cadastro-cargos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        main="TcWeb"
        icon="mdi-pencil-box-outline"
        sub="Cargos e funções"
        home="/home"
      />
      <page-cad />
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import PageCad from './../components/cargos'
export default {
  name: 'CadastroCargos',
  components: { PageTitle, PageCad }
}
</script>
